export enum artworkTipsTranslationKey {
    laser= 'laser',
    full_color= 'full_color',
    embossed= 'emboss',
    debossed= 'deboss',
    casino= 'design_wrap',
    design_wrap= 'design_wrap',
    pad_print= 'pad_print',
    silkscreen= 'silkscreen',
    heat_transfer= 'heat_transfer_single_color',
    hot_stamp= 'hot_stamp'
}

export enum errorOperationNames {
    GET_IMPRINT_INFO = 'customize getImprintInfo',
    GET_ACCESS_TOKEN = 'getAccessToken',
    UPLOAD_LOGO = 'uploadLogo',
    UPDATE_CUSTOMIZATION_INFO = 'updateCustomizationInfo',
    GENERATE_DOC_REFRENCE_URL = 'generateDocRefUrl'
}